import RemoteAccountCreatePage from './RemoteAccountCreatePage'

export default RemoteAccountCreatePage
// eslint-disable-next-line import/export
export * from './RemoteAccountCreatePage'
